import React from "react";
import {Rating} from "@material-ui/lab";
import {useSelector} from "react-redux";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {getParamsFromString} from "../../Utils";

const RatingComponent = (props) => {
    const {component = {}, setValue, actionsContext, screenName} = props;
    const {properties = {}, styles: sourceStyles} = component;
    const {globalValues} = useSelector(state => state.jsonScreen);
    const styles = sourceStyles ? sourceStyles[0] : {};
    const ratingValue = getParamsFromString(`{${properties.path}}`,{...globalValues, ...actionsContext}, screenName)
    return (
        <div style={styles}>
            <Rating
                style={{
                    color: styles.color,
                    fontSize: styles.fontSize,
                }}
                size={styles.size || "medium"}
                value={ratingValue}
                onChange={(e, v) => setValue(v, properties.path)}
                readOnly={properties.readOnly}
                disabled={properties.disabled}
            />
        </div>
    )
}
export default JsonScreenHoc(RatingComponent)